const C = require("../constants");

const selectTax = (data) => {
    return {
        type: C.TAX_SELECT,
        data
    }
};

export {selectTax};


// WEBPACK FOOTER //
// ./src/actions/TaxSelectActions.js